import useHistoryNavigation from 'app/hooks/useHistoryNavigation'

import BaseCollapsibleTable from './BaseCollapsibleTable'
import {
    CollapsibleTableProps,
} from './CollapsibleTableProps'

export default function NavigatedCollapsibleTable(props: Readonly<CollapsibleTableProps>) {
    const {
        routeParams,
    } = props
    const {
        id,
        action,
        updatePathWithId,
        updatePathWithParams,
    } = useHistoryNavigation(routeParams)

    return (
        <BaseCollapsibleTable
            {...props} // eslint-disable-line react/jsx-props-no-spreading
            formAction={action}
            formId={id}
            updateFormId={updatePathWithId}
            updateFormParams={updatePathWithParams}
        />
    )
}
